import React from 'react';
import {css, keyframes} from '@emotion/core';
import styled from '@emotion/styled';
import { Modal } from 'antd';
import CommonButton from '../common/Button/Button';
import { fontSize, colors } from '../../constants';
import { themeColors } from '../../constants/themes';

export const VideoModal = styled(Modal)`
  position: static;
  div.ant-modal-content {
    position: static;
    >button.ant-modal-close {
      top: 3em;
      right: 3em;
      >span.ant-modal-close-x {
        font-size: 3em;
        color: rgba(255, 255, 255, 0.45);
      }
      >span.ant-modal-close-x:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
    >div.ant-modal-body {
      padding: 0;
      >*{
        transform: translateX(-50%);
      }
    }
  }
`;
const fillBar = keyframes`
  from {
    width: 0;
  }
  to {
    width: 96%;
  }
`;

const BigText=styled.h2`
  font-family: Heebo;
  font-size: ${fontSize.large};
  line-height: 1;
  letter-spacing: 0.1px;
  text-align: left;
  font-weight: bold;
  color: ${colors.greySecondary};
  margin-top: 0.5em;
  display: inline-block;
`;

export const CountDown = props => {
  return (
    <div
      css={css`
        width: ${props.width}px;
        height: ${props.height}px;
        position: absolute;
        top: calc(50vh - ${props.height/2 + 12}px);
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        css={css`
          background: ${colors.whiteLightBackground};
          width: ${props.width/2}px;
          height: ${props.height/2}px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          border-radius: 1em;
        `}
      >
        <BigText>{props.message}</BigText>
        <div
          css={css`
              height: 2em;
              width: 90%;
              border-radius: 2em;
              background-color: ${colors.whiteDarkBackground};
              margin: 2em 0;
              display: flex;
              justify-content: center;
            `}
        >
          <div
            css={css`
              height: 1em;
              margin-top: 0.5em;
              border-radius: 1em;
              background-color: ${themeColors.blue};
              animation: ${fillBar} ${props.animationTime} linear;
            `}
          />
        </div>
        <CommonButton
          clickHandler={props.onCancelNext}
          width="30%"
        >
          Cancel
        </CommonButton>
      </div>
    </div>
  );
}
